import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c55ab3aa"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c55ab3aa')) {
      api.createRecord('c55ab3aa', component.options)
    } else {
      api.reload('c55ab3aa', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c55ab3aa", function () {
      api.rerender('c55ab3aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/bulk-message/table/index.vue"
export default component.exports